import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzAssignSecurityServersWebComponent } from './component/GzAssignSecurityServersWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { AssignSecurityServersPayload } from './types';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';

export class AssignSecurityServersPopUp extends NetworkBasePopUp<GzAssignSecurityServersWebComponent> {
  protected title = translateFn('Assign Security Servers');
  protected extraDialogConfigs: Partial<GzDialog> = { isWindow: true };

  protected customSetup() {
    if (!this.data.targets || this.data.targets.length === 0) {
      console.error('Could not open popup. Missing targets.');
      return;
    }

    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Assign'),
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];
    this.popUpContent = new GzAssignSecurityServersWebComponent();
    this.popUpContent.targetIds = this.data.targets.map(target => target._id);
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload: AssignSecurityServersPayload = {
      targetsIds: this.popUpContent.targetIds,
      securityServersEndpointIds: this.popUpContent.getFutureSecurityServerEndpointIds(),
    };

    try {
      const response = await ConsoleRequest.createRequest<{ success: boolean }>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'ProtectedEntitiesEPS',
        method: 'assignSecurityServers',
        payload: payload,
      });

      if (response.success) {
        this.showCustomToast(translateFn('Security Servers successfully assigned.'));
      } else {
        this.showErrorToastNotification(translateFn('Failed to assign Security Servers.'));
      }
    } catch (e) {
      this.showErrorToastNotification(translateFn('Failed to assign Security Servers.'));
    }
  }
}
